var map = {
	"./burger/cheesedlx_bb.png": 9667,
	"./burger/mcroyaldlx_bb.png": 9401,
	"./burger/sausagebg_bb.png": 7616,
	"./burger/xMcSpicy_281_29.png": 5763,
	"./burger/xchickbg.png": 162,
	"./burger/xdoublecheese_bb.png": 5128,
	"./burger/xfof_bb.png": 239,
	"./burger/xmcchickendlx_bb.png": 613,
	"./burger/xmcroyal_bb.png": 1499,
	"./coffee/da/iced_VNcoffee.png": 6292,
	"./coffee/da/iced_milkVNcoffee.png": 9801,
	"./coffee/da/icedamericano.png": 3766,
	"./coffee/da/icedlatte.png": 3781,
	"./coffee/da/xicedmatcha.png": 2801,
	"./coffee/da_xay/caramelfrappe.png": 5800,
	"./coffee/da_xay/chocofrappe.png": 1705,
	"./coffee/da_xay/lattefrappe.png": 2217,
	"./coffee/da_xay/mochafrappe.png": 1657,
	"./coffee/da_xay/xfrappematcha.png": 4395,
	"./coffee/nong/americano.png": 2054,
	"./coffee/nong/cappucino.png": 9107,
	"./coffee/nong/hotchoco.png": 7674,
	"./coffee/nong/hotlatte.png": 9774,
	"./coffee/nong/mocha.png": 3333,
	"./coffee/nong/xhotmatcha.png": 874,
	"./coffee/sua_chua/xY-1.png": 5241,
	"./coffee/sua_chua/xyogurt-dau.png": 3927,
	"./coffee/sua_chua/xyogurt-kiwi.png": 4441,
	"./ga_ran/x1-ga-ran.png": 9616,
	"./ga_ran/x10-wings.png": 30,
	"./ga_ran/x3-ga-ran.png": 10,
	"./ga_ran/x3pcs_chicken_mcwings.png": 2736,
	"./ga_ran/x5-ga-ran.png": 9332,
	"./ga_ran/x6-wings.png": 545,
	"./nuoc_uong/xProduct_thumb_Sprite.png": 2441,
	"./nuoc_uong/xdasani_water.png": 9195,
	"./nuoc_uong/xhero-pdt-Fanta-201703_0.png": 7246,
	"./nuoc_uong/xmcd-food-beverages-soft-drinks-coke.png": 4443,
	"./nuoc_uong/xmilk_300x300.png": 2182,
	"./nuoc_uong/xmilo.png": 2020,
	"./trang_mieng/banh_ngot/xBAKED-CHEESECAKE.png": 7829,
	"./trang_mieng/banh_ngot/xBANANA-MUFFIN.png": 4533,
	"./trang_mieng/banh_ngot/xCHOCO-BROWNIE.png": 8193,
	"./trang_mieng/banh_ngot/xCHOCOLATE-CHIP-COOKIE.png": 3930,
	"./trang_mieng/banh_ngot/xCOCONUT-MACAROON.png": 2854,
	"./trang_mieng/banh_ngot/xcroissant.png": 9514,
	"./trang_mieng/suachua_kem/xhotfudge_mcsundae.png": 6633,
	"./trang_mieng/suachua_kem/xmcdonalds_cone.png": 6929,
	"./trang_mieng/suachua_kem/xmcfmc.png": 4402,
	"./trang_mieng/suachua_kem/xoreo_mcflurry.png": 846,
	"./trang_mieng/suachua_kem/xstrawberry-mcsundae.png": 7204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6433;